import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"

import * as S from "./form.css"
import { FormBtn } from "./form.css"
import loadingSrc from "../../images/loading.svg"
import formatError from "../../utils/formatError"
import { NEWSLETTER_URL, EMAIL_REGEX } from "../../utils/constants"

const Form: React.FC<{ onSuccess?: () => void }> = ({
  onSuccess = () => null,
}) => {
  const {
    contentYaml: { homepage: data },
  }: IForm = useStaticQuery(query)

  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<React.ReactNode>()
  const [disabled, setDisabled] = React.useState(true)
  const [email, setEmail] = React.useState("")

  const onChange = (e: any) => setEmail(e.target.value)

  const onSubmit = async (e: any) => {
    e.preventDefault()

    if (!EMAIL_REGEX.test(email)) {
      return null
    }

    try {
      setLoading(true)

      const payload = {
        body: JSON.stringify({ email }),
        method: "POST",
      }

      const result = await fetch(NEWSLETTER_URL, payload)
      const response = await result.json()

      if (response.status === 400) {
        setError(formatError(response.title, email))
      } else {
        setEmail("")
        onSuccess()
      }
    } catch (err) {
      setError(formatError())
    }

    return setLoading(false)
  }

  React.useEffect(() => {
    setDisabled(!EMAIL_REGEX.test(email))
    setError("")
  }, [email])

  const buttonText = loading ? (
    <img src={loadingSrc} alt="loading" />
  ) : (
    data.form.button
  )

  return (
    <>
      <S.Form onSubmit={onSubmit}>
        <input
          name="email"
          type="email"
          value={email}
          placeholder={data.form.placeholder}
          onChange={onChange}
        />

        <FormBtn
          onClick={onSubmit}
          type="button"
          disabled={loading || disabled}
        >
          <span className="normal-view">{buttonText}</span>
          <span className="small-view">Subscribe</span>
        </FormBtn>
      </S.Form>
      <S.MessageError>{error}</S.MessageError>
    </>
  )
}

export default Form

interface IForm {
  contentYaml: {
    homepage: {
      form: {
        placeholder: string
        button: string
      }
    }
  }
}

const query = graphql`
  query Form {
    contentYaml(homepage: { button: { ne: null } }) {
      homepage {
        form {
          placeholder
          button
          success {
            title
            text
          }
        }
      }
    }
  }
`
